export const AI_PROMPT_TEMPLATE_KIND = 'ai_prompt'

export const DEFAULT_AI_IMAGE_SIZE = '1536x864'

export const AI_IMAGE_SIZE_OPTIONS = [
  { value: '1536x864', label: 'Widescreen (16:9, 1536 × 864)' },
  { value: '864x1536', label: 'Portrait (9:16, 864 × 1536)' },
  { value: '1024x1024', label: 'Square (1024 × 1024)' },
]

export const EMPTY_AI_PROMPT_FIELDS = {
  titleTheme: '',
  overallFeel: '',
  stats: '',
  layoutSize: '',
  images: '',
  advanced: '',
}

export function normalizeAiPromptFields(value = {}) {
  return {
    ...EMPTY_AI_PROMPT_FIELDS,
    titleTheme: value.titleTheme || value.title_theme || '',
    overallFeel: value.overallFeel || value.overall_feel || '',
    stats: value.stats || '',
    layoutSize: value.layoutSize || value.layout_size || '',
    images: value.images || value.subjects || '',
    advanced: value.advanced || value.advanced_instructions || '',
  }
}

export function buildImagePrompt(fields = EMPTY_AI_PROMPT_FIELDS) {
  const normalized = normalizeAiPromptFields(fields)
  const sections = [
    ['Title/theme', normalized.titleTheme],
    ['Overall feel', normalized.overallFeel],
    ['Stats to include', normalized.stats],
    ['Layout/size', normalized.layoutSize],
    ['Images/subjects', normalized.images],
    ['Advanced instructions', normalized.advanced],
  ].filter(([, value]) => String(value || '').trim())

  if (!sections.length) return ''

  return [
    'Create a polished sports wagering poster for Wager Studio.',
    'Keep text legible, avoid invented stats, preserve exact numbers and names supplied by the operator, and do not add logos unless specified.',
    ...sections.map(([label, value]) => `${label}: ${String(value).trim()}`),
  ].join('\n')
}

export function aiPromptFieldsFromTemplate(template) {
  return normalizeAiPromptFields(template?.defaults?.ai_image_prompt?.fields || template?.defaults?.ai_image_prompt || {})
}

export function aiPromptTextFromTemplate(template) {
  const prompt = template?.defaults?.ai_image_prompt?.compiled_prompt
  if (String(prompt || '').trim()) return String(prompt).trim()
  return buildImagePrompt(aiPromptFieldsFromTemplate(template))
}

export function aiPromptTemplatePayload(name, fields, prompt, isDefault = false) {
  const normalized = normalizeAiPromptFields(fields)
  const compiledPrompt = String(prompt || '').trim() || buildImagePrompt(normalized)
  return {
    name: name.trim(),
    description: null,
    template_kind: AI_PROMPT_TEMPLATE_KIND,
    asset_ids: [],
    defaults: {
      ai_image_prompt: {
        fields: normalized,
        compiled_prompt: compiledPrompt,
        is_default: isDefault,
      },
    },
    is_active: true,
  }
}

export function aiAssetTitle(fields, fallback = 'AI generated poster') {
  const title = String(fields?.titleTheme || '').trim()
  return title ? title.slice(0, 80) : fallback
}

export function aiPromptFallbackName(fields, prompt, presetName) {
  const fieldTitle = String(fields?.titleTheme || '').trim()
  if (fieldTitle) return fieldTitle.slice(0, 80)
  if (presetName) return presetName
  const firstLine = String(prompt || '').trim().split('\n').find(Boolean)
  return firstLine ? firstLine.slice(0, 80) : 'AI poster direction'
}
